import StatusActiveIcon from '@/components/icons/StatusActiveIcon';
import StatusInactiveIcon from '@/components/icons/StatusInactiveIcon';
import StatusSuspendedIcon from '@/components/icons/StatusSuspendedIcon';
import { OwnerStatus } from '@/features/owners/types/owners-dto';

const getStatusData = (status: OwnerStatus) => {
	switch (status) {
		case OwnerStatus.Active:
			return {
				label: 'main.owners.status.active',
				icon: StatusActiveIcon,
				iconStyles: 'fill-status-active',
				statusStyles: 'bg-status-active'
			};
		case OwnerStatus.Inactive:
			return {
				label: 'main.owners.status.inactive',
				icon: StatusInactiveIcon,
				iconStyles: 'fill-status-inactive',
				statusStyles: 'bg-status-inactive'
			};
		case OwnerStatus.Suspended:
			return {
				label: 'main.owners.status.suspended',
				icon: StatusSuspendedIcon,
				iconStyles: 'fill-status-suspended',
				statusStyles: 'bg-status-suspended'
			};			
	}
};


export const OwnersUtils = {
	getStatusData
};
